import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import * as Icons from "@/components/fun-ui/icons"
import { FetchPaperOrder } from "@/stores/slices/paperSlice"
import { cn } from "@/lib/utils";

interface SortSelectProps {
  onSortChange: (value: FetchPaperOrder) => void;
  value?: FetchPaperOrder;
}

const SortSelect = ({ onSortChange, value = "create_time,desc" }: SortSelectProps) => {
  const sortOptions: {
    value: FetchPaperOrder;
    label: string;
    icon: keyof typeof Icons;
  }[] = [
      { value: "create_time,desc", label: "按上传时间从 近 到 远 排序", icon: "TimeSortIcon" },
      { value: "create_time,asc", label: "按上传时间从 远 到 近 排序", icon: "TimeSortIcon" },
      { value: "title,asc", label: "按文献名从 A 到 Z 排序", icon: "SortAscendingIcon" },
      { value: "title,desc", label: "按文献名从 Z 到 A 排序", icon: "SortDescendingIcon" },
      { value: "year,desc", label: "按年份从 近 到 远 排序", icon: "YearSortIcon" },
      { value: "year,asc", label: "按年份从 远 到 近 排序", icon: "YearSortIcon" },
    ];

  // const selectedIconName = useMemo(() => {
  //   return sortOptions.find(item => item.value === selectedValue)?.icon || 'SortIcon';
  // }, [sortOptions, selectedValue]);

  // const SelectedIcon = Icons[selectedIconName];

  return (
    <Select
      onValueChange={onSortChange}
      value={value}
    >
      <SelectTrigger className={cn(
        "w-fit bg-background flex gap-1 h-6 text-sm text-muted-foreground py-0 px-2 leading-6 select-none cursor-pointer",
        value !== sortOptions[0].value && 'text-primary'
      )}>
        <Icons.SortIcon /> <span>排序</span>
      </SelectTrigger>
      <SelectContent className="px-2 py-3" align="center">
        {sortOptions.map((option) => {
          const Icon = Icons[option.icon];
          return (
            <SelectItem key={option.value} value={option.value}
              className="text-muted-foreground py-0 pl-3 rounded-md data-[state='checked']:text-primary data-[state='checked']:bg-background text-sm select-none cursor-pointer"
            >
              <span className="inline-flex items-center gap-3 text-sm leading-4 align-baseline py-2.5">
                <Icon /><span>{option.label}</span>
              </span>
            </SelectItem>
          )
        })}
      </SelectContent>
    </Select>
  )
}

export default SortSelect